import { Injectable } from "@angular/core";

    /**
     * @description
     *  Servicio de acceso al almacenamiento local.
     */

@Injectable({ providedIn: "root" })
export class LocalStorageService {

    constructor() {}

    /**
     * @description
     *  Obtiene un objeto almacenado localmente bajo cierta clave.
     *
     * @param key
     *  La clave bajo la cual se encuentra registrado el objeto.
     *
     * @returns
     *  El objeto, con el tipo especificado, o 'undefined' si no había un
     *  objeto bajo la clave especificada.
     */
    public getObject<T>(key: string): T {
        const value = localStorage.getItem(key);
        if (value === null) {
            return undefined;
        }
        else {
            return JSON.parse(value) as T;
        }
    }

    /**
     * @description
     *  Obtiene una cadena almacenada localmente bajo cierta clave.
     *
     * @param key
     *  La clave bajo la cual se encuentra registrada al cadena.
     *
     * @returns
     *  La cadena buscada, o 'undefined' si no había una cadena bajo la clave
     *  especificada.
     */
    public getString(key: string): string {
        const value = localStorage.getItem(key);
        if (value === null) {
            return undefined;
        }
        else {
            return value;
        }
    }

    /**
     * @description
     *  Elimina un objeto o cadena almacenado localmente bajo cierta clave.
     *
     * @param key
     *  La clave bajo la cual se registra el objeto o cadena a eliminar.
     *
     * @returns
     *  Este mismo servicio.
     */
    public remove(key: string): LocalStorageService {
        localStorage.removeItem(key);
        return this;
    }

    /**
     * @description
     *  Alamcena un objeto localmente, serializándolo como cadena para que no
     *  pierda su estructura al recuperarlo.
     *
     * @param key
     *  La clave bajo la cual almacenar el objeto.
     * @param value
     *  El objeto a almacenar.
     *
     * @returns
     *  Este mismo servicio.
     */
    public saveObject<T>(key: string, value: T): LocalStorageService {
        return this.saveString(key, JSON.stringify(value));
    }

    /**
     * @description
     *  Alamcena una cadena localmente.
     *
     * @param key
     *  La clave bajo la cual almacenar la cadena.
     * @param value
     *  La cadena a almacenar.
     *
     * @returns
     *  Este mismo servicio.
     */
    public saveString(key: string, value: string): LocalStorageService {
        localStorage.setItem(key, value);
        return this;
    }
}
